
import { HistoryDto } from '@/endpoints/models'
import { useAppContext } from '@/hooks'
import { toLocaleString } from '@/utils/numbers'

interface LastVersionInfoProps {
	data: HistoryDto | undefined
}

const LastVersionInfo = ({ data }: LastVersionInfoProps) => {
	const { t } = useAppContext()

	if (data) {
		return (
			<>
				<span data-testid="last-version_info" data-version={data.version}>
					{t('LAST_VERSION', [data.version, data.authorName])}
				</span>
				<span>&nbsp;{toLocaleString(data.created)}</span>
			</>
		)
	}

	return <span>N/A</span>
}

export default LastVersionInfo
